<template lang="html">
  <ul class="label-list">
    <li class="label" v-for="(label, index) in list" :class="{'selected':selected === index}" @click="clickHandler(index)">{{label}}</li>
  </ul>
</template>

<script>
export default {
  data() {
    return {
      selected: null
    }
  },
  props: ['list'],
  computed: {},
  mounted() {},
  methods: {
    clickHandler(index) {
      if (this.selected === index) {
        this.list.splice(index, 1)
      } else {
        this.selected = index
      }
    }
  },
  watch: {
    list() {
      this.selected = null
    }
  },
  components: {}
}
</script>

<style lang="css">
#app .label-list {
  list-style: none;
  margin: 0 auto;
  padding: 0;
  width:90%;
}

#app .label {
  display: inline-block;
  position:relative;
  margin:0.3em 0.5em;
  text-transform: uppercase;
  font-size: 0.9em;
  line-height: 1.5;
  cursor:pointer;
  vertical-align: middle;
}

#app .label.selected {
  background-color: #f2f2f2;
  border-radius: 1em;
  padding: 0 0.2em 0 0.5em;
}

#app .label::after {
  content:"\2715";
  display: none;
  color:white;
  background-color: #2c3e50;
  border-radius: 1em;
  font-weight: bold;
  font-size: 0.8em;
  margin-top:-0.15em;
  margin-left:0.2em;
  width: 1.4em;
  vertical-align: middle;
}

#app .label.selected::after {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// LabelList.vue?0f24f5b0